module.exports = __webpack_public_path__ + "media/images/icons/icon_pageType_02-bcce3ddfffa8ee0715daf3feea7e6add.svg";